import { render } from "./TeachersSubject.vue?vue&type=template&id=c7632c20"
import script from "./TeachersSubject.vue?vue&type=script&lang=js"
export * from "./TeachersSubject.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__